module.exports = __webpack_public_path__ + "static/model-tiv-card-144d4dd8d22ab9ee859fdf868e17e97d.png";